import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OptionValue, SurveyLine } from 'src/app/models/survey-header.model';

@Component({
  selector: 'app-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
})
export class SelectOptionComponent implements OnInit {

  @Input() question: SurveyLine;

  @Output() selectedOptions = new EventEmitter<string[]>();

  option: OptionValue;

  selectedOptionsValues: string[] = [];
  constructor() { }

  ngOnInit() {
    this.option = this.question.option_values;
  }

  selectedOptionsChanged(option: string, type: string) {

    if (type === 'multiple') {
      if (this.selectedOptionsValues.includes(option)) {
        this.selectedOptionsValues = this.selectedOptionsValues.filter(x => x !== option);
      } else {
        this.selectedOptionsValues.push(option);
      }
    } else {
      this.selectedOptionsValues = [option];
    }

    this.selectedOptions.emit(this.selectedOptionsValues);

  }
}
